module.exports = __webpack_public_path__ + "static/media/spotify-app.09526e05.png";